/* eslint-disable no-new */

import * as types from './mutation-define'
import msgpad_show from "../msgpad_show"
import * as API from "@/api/module/products"

/*
gid:条码
name:名称
num:数量

is_weight:是否称重
unit:[pc-件,g-克,kg-公斤,500g-斤]
vip:[vip-注册会员,copper-铜牌会员,silver-银牌会员,gold-金牌会员,diamond-钻石会员]
vip_price:[vip-注册会员,copper-铜牌会员,silver-银牌会员,gold-金牌会员,diamond-钻石会员]

sale_price:零售价
-real_price:实际销售价

save_take:[sale-销售,take-提货]
all_num: 存货总数量
save_number: 暂存数量
less: 减免
-discount:折扣

*/


const state = {
    pay_info :{
        pay_type   :"cash",
        pay_status :0,
        bank_id    :"",
        use_prepay :0,
        total_money:0,
        recv       :0,
        ret        :0,
        other      :0
    },
    list: [],
    make_to_int  :0,
    outsea_products:{},
    multil_index :0,
    amount_less  :0,//积分抵现
    use_prepay   :0,//储值卡消费
    order_id : +new Date(),
    note : ''
}

function have_this_gid(gid){
    for(var i = 0;i<state.list.length;i++){
        let item = state.list[i];
        if(item.gid == gid){
            return i;
        }
    }
    return -1;
}

    // getters
const getters = {
        /*{
            list         :state.list,
            make_to_int  :state.make_to_int,
            multil_index :state.multil_index,
            amount_less  :state.amount_less,
            order_id     :state.order_id,
            note         :state.note}*/
    get_order_raw        : state => {return state},
    get_order_id         : state => state.order_id,
    get_order_note       : state => state.note,
    
    get_pay_info         : state => state.pay_info,
    get_outsea_products  : state => state.outsea_products,
    get_prodcuts_list    : state => state.list,
    get_mutil_index      : state => state.multil_index,
    get_use_prepay_money : state => state.use_prepay,
    get_amount_less      : state => state.amount_less,
    get_selected_num     : state => {
        let num = 0;
        state.list.map(it=>{
            if(it.selected) num++;
        })
        return num;
    },
    get_product_money : (state, getters) => (gid) => {
            var item     = state.list[have_this_gid(gid)];
            var t_money  = item.real_price * item.num - (item.less?item.less:0);
            return t_money.toFixed(2)*1;
    },
    have_this_gid:(state, getters) => (gid) => {
            let index = have_this_gid(gid);
            return (index >=0)
    },
    get_product_discount: (state, getters) => (gid) => {
        var item = state.list[have_this_gid(gid)];
        if(item.real_price * item.num * item.sale_price ==0) return 0;
        return parseInt((item.real_price * item.num - item.less)*100 / (item.sale_price*item.num))
    },
    get_products_sum_info: (state,getters) =>{
        var [total_num,total_save_num, total_money, 
            total_discount, total_less,less_to_int]=[0,0,0,0,0,0,0];
        var amount_less = state.amount_less;
        var use_prepay  = state.use_prepay;
        var [all_salemoney,total_real_price] = [0,0];
        for(var i = 0;i<state.list.length;i++){
            let item = state.list[i];
            if(item.save_take == 'sale'){
                total_save_num += item.save_num?item.save_num:0;
            }
            if(item.is_weight){
                total_num += 1;
            }else{
                total_num += item.num;
            }
            all_salemoney    += item.sale_price * item.num ;
            total_real_price += item.real_price * item.num - item.less;
        }

        total_less  = all_salemoney - total_real_price;
        total_less  = total_less.toFixed(2)*1;

        if(all_salemoney < 0.01){
            total_discount = 0;
        }else{
            total_discount  = parseInt(total_real_price * 100 / all_salemoney)
        }

        total_money = total_real_price - state.amount_less;
        if(state.make_to_int){
            less_to_int = total_money - parseInt(total_money);
            total_money -= less_to_int;
        }
        var pay_status = state.pay_status;
        if(use_prepay > total_money) use_prepay = total_money;
        if(use_prepay < 0) use_prepay = 0;
        return {pay_status,total_num,total_save_num,total_money,
            total_less,total_discount,amount_less,less_to_int,use_prepay};
    },
    get_sale_post_data:function(state,getters){
        //use_prepay
        let {pay_status,total_num,total_save_num,total_money,
             total_less,total_discount,amount_less,less_to_int,use_prepay} = 
            getters.get_products_sum_info;

        let sum = {total_num,total_save_num,total_money,use_prepay,
            total_less,total_discount,amount_less,less_to_int};

        let vip = {
            vip_mobile   : getters.vip_info.mobile,
            vip_discount : sum.total_discount
        };

        let detail =[];
        for(let item of state.list){
            detail.push({
                gid       : item.gid,
                nm        : item.name,
                num       : item.num,
                price     : item.sale_price,
                realprice : item.real_price,
                discount  : item.discount,
                money     : getters.get_product_money(item.gid),
                less      : item.less,
                save_num  : item.save_num,
                flag      : item.save_take,
                is_new    : item.is_new?true:false,
                isEMS     : item.isEMS?true:false,
                outsea    : item.outsea?true:false,
                change_to : item.change_to ? item.change_to : null,
            })
        }

        return {
            order_id : state.order_id,
            sum      : sum,
            detail   : detail,
            note     : state.note,
            vip      : vip
        }
    },
    get_shipout_data:function(state,getters){

        let out_obj = {
            order_id : state.order_id,
            total_num: getters.get_products_sum_info.total_num,
            items : []
        }

        for(let item of state.list){
            out_obj.items.push({
                gid  : item.gid,
                num  : item.num,
                info : item.name,
                flag : item.save_take
            })
        }
        return out_obj;
    }
}

// actions
const actions = {
    act_lookup_products_by_gid({commit}, {gid,prepare,callback,self,raw} ) {
        // let url = "/product?oper=lookup&gid="+gid;
        // let url = "/api/pos/product?oper=lookup&gid="+gid;
        // console.log("URL:",url)
        return API.lookup_products_by_gid(gid).then(resp=>{
            if(resp.status == 200){
                let data = resp.data;
                // console.log("RECV:",data,commit)
                if(raw) return data;
                commit("PRODUCTS_RESPONS_LIST",{data,gid,commit,callback,prepare,self});
                return data;
                // if(callback){callback(data);}
            }else if(!prepare){
              msgpad_show("msgpad","失败",resp.data.err_msg,'error')
            }
        }).catch(function(err){
              msgpad_show("msgpad","NETWORK_ERROR",err.message,'error')
        })
    },
    act_lookup_home_stock({commit}, {gid,name,prepare,callback,self} ) {
        // let url = "/product?oper=lookup&gid="+gid;
        // let url = "/api/pos/product?oper=lookup&gid="+gid;
        // console.log("URL:",url)
        API.lookup_home_stock({gid}).then(resp=>{
            if(resp.status == 200){
                let data = resp.data;
                console.log("RECV:",data,commit)
                commit("PRODUCTS_RESPONS_LIST",{data,gid,commit,callback,prepare,self});
                // if(callback){callback(data);}
            }else if(!prepare){
              msgpad_show("msgpad","失败",resp.data.err_msg,'error')
            }
        }).catch(function(err){
              msgpad_show("msgpad","NETWORK_ERROR",err.message,'error')
        })
    },
    act_ship_out_products({commit,state,getters},{type,param,self}){
        function post_products(post_url,obj,dlg,ok_callback) {
            if(vue_products.total_info.total_num == 0){
                bootbox.alert("<h3>商品列表为空</h3>")
                return;
            }
            var post_data = {};
            if(typeof obj != "undefined")
                Object.keys(obj).forEach(function(key){
                    post_data[key] = obj[key];
                })

            post_data.items = [];
            /*if (vue_products.order_id == 0) {
                var d = new Date();
                vue_products.order_id = d.getTime();
            }*/

            post_data.order_id = get_sale_order_id();//vue_products.order_id;
            post_data.total_num = vue_products.total_info.total_num;

            Object.keys(vue_products.$data.list).forEach(function(key) {
                var obj = vue_products.$data.list[key];
                post_data.items.push({
                    gid: obj.gid,
                    num: obj.num,
                    info: obj.name,
                    flag:obj.save_take
                });
            })
        }

    }
}


function rest_vip_price(item,vip){
    // debugger
    //vip-注册会员,copper-铜牌会员,silver-银牌会员,gold-金牌会员,diamond-钻石会员
    if(vip=="注册会员") vip="vip";
    else if(vip=="铜牌会员") vip="copper";
    else if(vip=="银牌会员") vip="silver";
    else if(vip=="金牌会员") vip="gold";
    else if(vip=="钻石会员") vip="diamond";
    
    item['less'] = 0;

    if(vip && item.vip_price&& typeof(item.vip_price[vip]) != 'undefined'){
        var real_price = item.vip_price[vip];
        item['default_vip_price'] = item['real_price'] = item.vip_price[vip];//vip price
    }else{
        item['default_vip_price'] = item['real_price'] =item.sale_price;
        if(item.vip_price && typeof(item.vip_price['vip']) != 'undefined')
            item['default_vip_price'] = item.vip_price['vip']
    }

    console.log("[%s]====> REAL:%s DEF_VIP:%s",vip,item['sale_price'],item['default_vip_price'] )

    if(item['real_price'] > item['sale_price']){
        item['real_price'] = item['sale_price'];
         return msgpad_show("msgpad","ERROR",'会员价格高于零售价','error')
    }
}

const mutations = {

    [types.PAYINFO_SETTING] (state, info) {
      state.pay_info = info;
    },
    [types.USE_PREPAY_MONEY] (state, money) {
        state.use_prepay = money;
    },

    [types.PRODUCTS_SELECT_ALL] (state, flag) {
        state.list.map(it=>{ it.selected = flag} )
    },
    [types.PRODUCTS_RESTORE_LIST] (state, obj) {
      // debugger
      if(obj){
        console.log("==",Object.keys(obj))
         for(let key of Object.keys(obj)){
            if(key == 'vip') continue;
            state[key] = obj[key]
         }
      }
    },
   
   [types.PRODUCTS_DISCOUNT_SELECTED] (state, discount) {
        state.list.map(it=>{
            if(it.selected){
                it['real_price'] = it.sale_price * discount/100;
                it['less'] = 0;
            }
        })
    },

    [types.PRODUCTS_RESET_VIP_PRICE](state,vip_group) {
        // debugger
        let need_del = [];
        for(let i =0;i<state.list.length;i++){
            let item = state.list[i];
            if(!vip_group){
                if(item.save_take == 'take'){
                    need_del.push(item.gid);
                    continue;
                }
                item.save_num = 0;
            }
            rest_vip_price(item,vip_group);
        }
        state.amount_less = 0.0;
        state.make_to_int = false;

        need_del.map(gid=>{
            var index = have_this_gid(gid);
            if(index >=0){
                let item = state.list[index];
                state.list.splice(index,1);
            }
        })
    },

    [types.PRODUCTS_LIST_INC_MUL_INDEX](state,val=1) {
        state.multil_index += val;
    },

    [types.PRODUCTS_LIST_CLEAN](state) {

        state.list         = [];
        state.make_to_int  = 0,
        state.multil_index = 0;
        state.amount_less  = 0;
        state.use_prepay   = 0;
        state.order_id     = +new Date();
        state.note         = '';
        state.outsea_products ={};
        state.pay_info     = {
            pay_type   :"cash",
            pay_status :0,
            bank_id    :"",
            recv       :0,
            ret        :0,
            other      :0
        };
    },
    [types.PRODUCTS_NEW_ORDER_ID](state) {
        state.order_id = + new Date();
    },
    [types.PRODUCTS_EDIT_NOTE](state,note) {
        state.note = note;
    },
    [types.PRODUCTS_RESPONS_LIST](state, {data,gid,commit,callback,prepare,self}) {
        if (data.data)
            data = data.data;
        if (data.length == 0) {
            commit(types.PRODUCTS_PREPARE_LIST,data);
            if(!prepare){
                msgpad_show("msgpad","ERROR",'无此商品信息','error');
                // if(callback){
                //     callback(data,self);
                // }
            }
            return 
        }
        // console.log("PRODUCTS_RESPONS_LIST:",data,"from_gid",gid,"prepare:",prepare)
        if(!prepare || data.length ==1){
            // debugger
            for(var i = 0;i<data.length ;i++){
                if(data[i].gid == gid){
                    data[i].oper = 'add';
                    data[i].vip = self.$store.getters.vip_info.mobile;

                    commit(types.PRODUCTS_EDIT_ITEM,data[i]);
                    // self.$root.$emit("active_sale_tab",0);
                    // self.$root.$emit('clear_input')
                    let act_tab = 'tab-sale';
                    callback&&callback(data,act_tab)
                    console.log("Active table!",act_tab);
                    return; 
                }
            }
        }
        commit(types.PRODUCTS_PREPARE_LIST,data);
        // self.$root.$emit("active_sale_tab",1);
        callback&&callback(data,"tab-prepare")
        return;
    },

    [types.PRODUCTS_EDIT_ITEM](state, detail) {
       
        let {oper,gid} = detail;
        var index = have_this_gid(gid);
        let item = state.list[index];

        console.log("PRODUCTS_EDIT_ITEM:",oper,gid,detail)

        if(state.pay_info.pay_status >0){
            return msgpad_show("msgpad","ERROR", '操作无效！本单位已结算','error');
        }

        if(oper == 'add'){
            if(index >= 0 ){
                item.num += detail.num?detail.num:1;
                state.list.splice(index,1);
                state.list.unshift(item);
                return; 
            }
            
            let {gid,name,num,is_weight,unit,vip,vip_price,sale_price,save_take,all_num,save_num,less,discount,isEMS=false,outsea=false} = detail;
            if(save_num === undefined)
                save_num = 0;
            if(save_take === undefined)
                save_take = 'sale';
            if( num=== undefined)
                num = 1;
            if( all_num=== undefined)
                all_num = 0;

            let n_obj = {gid,name,num,is_weight,unit,vip,vip_price,sale_price,save_take,all_num,save_num,less,discount,isEMS,outsea};
            n_obj.selected = false;
            n_obj.change_to = null;
            // console.log("New Obje:",n_obj,"VIP:",vip);
            rest_vip_price(n_obj,vip);
            state.list.unshift(n_obj);
            if(outsea){
                state.outsea_products[gid] = n_obj;
            }
            return;

        }else if(oper == 'make_to_int'){
            state.make_to_int  = !!detail.value;
            return ;
        }else if(oper == 'vip_use_amount'){
            state.amount_less  =  detail.value;
            return ;
        }

        if(index < 0 )
            return msgpad_show("msgpad","ERROR",'未发现商品:'+gid,'error')
        // console.log(item)
        switch(oper){
            case 'delete':
                state.list.splice(index,1);
                if(item.outsea)
                    delete state.outsea_products[item.gid];
                break;
            case 'return_it':
                item.num *=-1;
                break;
            case 'set_num':
                detail.value = detail.value*1 - item.num;
                // item.num = detail.value*1;
                // break;
            case 'inc_num':
                
                if(item.save_take == 'sale'){
                    // debugger
                    item.num += detail.value*1;
                    if(item.less/(item.real_price?item.real_price:1) > item.num){
                        msgpad_show("msgpad","ERROR",'重新计算减免赠送金额','error');
                        item.less = 0;
                    }
                    
                    if((item.save_num > item.num)  && item.num >=0){
                        item.save_num  = item.num
                    }else if(item.num < 0){
                        item.save_num  = 0;
                    }
                }else if(item.save_take == 'take'){
                    if(item.num + detail.value*1 > item.all_num){
                        return msgpad_show("msgpad","ERROR", item.name+':提货数量超过存放数量！','error')
                    }
                    if(item.num + detail.value*1 < 0){
                        return msgpad_show("msgpad","ERROR", item.name+':提货数量不能为0！','error')
                    }
                    item.num += detail.value*1;
                }
                if(item.num < 0){
                    item.num = 0;
                    return msgpad_show("msgpad","ERROR", item.name+':数量不能小于0;如果是退货，请选择"退货"！','error')
                }
                break;
            case 'set_less':
                item.less = detail.value;
                break;
            case 'free_it':
                // item.s
                if(item.real_price != item.sale_price){
                    item.real_price = item.sale_price;
                    item.less = 0;
                }
                item.less += item.real_price;
                break;
            case 'set_to_int':
                item.less += detail.value;
                break;
            case 'selected':
                item.selected = !item.selected;
                console.log("SELECTED:",item.selected)
                break;
            case 'set_discount':
                if(detail.value>0 && detail.value <=100){
                    item['real_price'] = item.sale_price * detail.value/100;
                    item.less = 0;
                }
                break;
            case 'inc_save':
                var inc = detail.value;
                if(item.save_take == 'take'){
                    return msgpad_show("msgpad","ERROR",'状态错误','error')
                }
                if(item.save_num + inc >item.num){
                    return msgpad_show("msgpad","ERROR",'寄存商品不能大于购买商品:','error')
                    item.save_num  = item.num
                }else if(item.save_num + inc < 0){
                    item.save_num  =  0;
                    return msgpad_show("msgpad","ERROR",'寄存商品不能小于0:','error')
                }else{
                    item.save_num += inc;
                }
                break;
            case 'set_real_price'://
                item.real_price  = detail.value;
                item.less = 0;
                break;
            case 'set_flag':
                item.save_take = detail.value;
                break;
            case 'set_ems':
                item.isEMS = !item.isEMS;
                break;
            case 'use_vip_price':
                rest_vip_price(item,detail.value)
                break;
            case 'change_saved_item_to':
                break;
            case 'make_to_int':
                state.make_to_int  = !!detail.value;
                break;
            // case 'vip_use_amount':
            //     state.amount_less  =  detail.value;
            //     break;
            default :
                return msgpad_show("msgpad","ERROR",'未知操作:'+oper,'error')
                break;
        }
    
    }

}


export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/products_store.js